export default "__VITE_ASSET__ncgze_7i__"